import styled from 'styled-components';

import { px } from '../../../../../contrib/ui';

export const InvitationsStyled = styled.div`
  width: 100%;
  transition: all 600ms 400ms cubic-bezier(0.645, 0.045, 0.355, 1);
  z-index: 2;
  padding: 0 ${px(14)};
`;
